module.exports = require("@swa-ui/application/src/SkipToContent/SkipToContent.module.scss");